import _ from "lodash";

const getters = {
  getCargandoRuta: state => {
    return state.cargandoRuta;
  },
  getEstrategias: state => {
    return state.estrategias.filter(e => e.activo);
  },
  getEstrategia: (state, getters) => {
    return _.find(getters.getEstrategias, { slug: getters.estrategia });
  },
  getSlugRegex: (state, getters) => {
    let estrategias = _.map(getters.getEstrategias, "slug");
    return `(${estrategias.join("|")})`;
  },
  valida: state => {
    return state.valida;
  },
  debeActualizar: state => {
    return state.debeActualizar;
  },
  cedula: state => {
    return state.cedula;
  },
  fechaNacimiento: state => {
    return state.fecha_nacimiento;
  },
  getDatosCPE: state => {
    return state.datos_cpe;
  },
  getDatosMEN: state => {
    return state.datos_men;
  },
  estrategia: state => {
    return state.estrategia;
  }
};

export default getters;
